import { AfterViewInit, Component, ElementRef, NgZone, OnDestroy, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { AuthService } from '../_services/auth.service';
import { UserService } from '../_services/user.service';
import { EngineService } from '../_services/engine.service';

import { AudioPlayerService } from '../_services/audio-player.service';
import { NavigationEnd, NavigationStart } from '@angular/router';

import { Router } from '@angular/router';

import { AudioTrackStoreService } from '../_services/audio-track-store.service';
import { filter, map, mergeMap, takeUntil } from 'rxjs/operators';
import { Observable, Subject, forkJoin, of, timer } from 'rxjs';
import { JwtClaims, JWTTokenService } from '../_services/jwtToken.service';
import { User } from '../_models/User';
import { TosComponent } from '../tos/tos.component';
import { BsModalService } from 'ngx-bootstrap/modal';
import { VendorService } from '../_services/fundraising/vendor.service';
import { Vendor } from '../_models/fundraising/Vendor';
import { EngineServiceType } from '../_models/ServiceType';
import { DialogService } from '../_services/dialog.service';
import { InactivityMonitorService } from '../_services/inactivity-monitor.service';

@Component({
  templateUrl: './portal.component.html',
  styleUrls: ['./portal.component.css'],
})
export class PortalComponent implements OnInit, AfterViewInit, OnDestroy {

  // @ViewChild('backgroundRef', { static: false })
  // private backgroundRef: ElementRef;

  @ViewChild('mainViewRef', { static: false })
  private mainViewRef: ElementRef;

  private _onDestroy$: Subject<void> = new Subject();

  private _hasUserManagement: boolean;
  get hasUserManagement() {
    return this._hasUserManagement;
  }

  private _hasSiteManagement: boolean;
  get hasSiteManagement() {
    return this._hasSiteManagement;
  }

  private _hasEditVendorPaymentInfo: boolean;
  get hasEditVendorPaymentInfo() {
    return this._hasEditVendorPaymentInfo;
  }

  private _hasFundraising: boolean;
  get hasFundraising() {
    return this._hasFundraising;
  }

  private _canEditVenues: boolean;
  get canEditVenues() {
    return this._canEditVenues;
  }

  private _authService: AuthService;
  get authService() {
    return this._authService;
  }

  private _userService: UserService;
  get userService() {
    return this._userService;
  }

  private _engineService: EngineService;
  get engineService() {
    return this._engineService;
  }

  private _hasWebsiteCustomization: boolean;
  get hasWebsiteCustomization() {
    return this._hasWebsiteCustomization;
  }

  private _hasPledgePerWin: boolean;
  get hasPledgePerWin() {
    return this._hasPledgePerWin;
  }

  private _cue5050Enabled: boolean;
  get cue5050Enabled() {
    return this._cue5050Enabled;
  }

  private _ppwEnabled: boolean;
  get ppwEnabled() {
    return this._ppwEnabled;
  }

  private interval: NodeJS.Timeout;

  private currrentRoute = '';

  public vendorId = 0;
  public vendor: Vendor;

  public enableBarrelPrinting = false;

  private bsModalRef: any;
  private tosDialogSubject: Subject<boolean>;

  public vendorPermissionConditions: boolean;

  private _serviceTypes: EngineServiceType[] = [];
  get serviceTypes() : EngineServiceType[] {
    return this._serviceTypes;
  }
  set serviceTypes(value: EngineServiceType[]) {
    this._serviceTypes = value;
  }

  /*
  private sineWaves: SineWave[] = [
    { phase: 0.4, amplitude: 76, frequency: 350, velocity: .01, color: 'rgb(240, 243, 252)' },
    { phase: 1.2, amplitude: 97, frequency: 150, velocity: .005, color: 'rgb(228, 232, 245)' },
    { phase: 3.1, amplitude: 113, frequency: 210, velocity: .002, color: 'rgb(221, 226, 240)' },
    { phase: 4.5, amplitude: 156, frequency: 250, velocity: .008, color: 'rgb(213, 217, 227)' },
    { phase: 5.3, amplitude: 213, frequency: 200, velocity: .004, color: 'rgb(215, 217, 222)' },
    { phase: 6.2, amplitude: 303, frequency: 270, velocity: .003, color: 'rgb(210, 211, 214)' },
  ];
  */

  instance: number;

  constructor(
    authService: AuthService,
    userService: UserService,
    engineService: EngineService,
    public router: Router,
    private audioStore: AudioTrackStoreService,
    private playerService: AudioPlayerService,
    private vendorService: VendorService,
    private modalService: BsModalService,
    private zone: NgZone,
    private jwtTokenService: JWTTokenService,
    private dialogService: DialogService,
    private viewRef: ViewContainerRef,
    private inactivityMonitor: InactivityMonitorService
  ) {
    this._authService = authService;
    this._userService = userService;
    this._engineService = engineService;

    router.events.subscribe((val) => {
      const nav = val as NavigationEnd;
      if (nav && nav.url) {
        this.currrentRoute = nav.url;
      }
    });

    router.events.pipe(filter(
      (event: NavigationStart) => event instanceof NavigationStart)
      ).subscribe(
        () => {
          this.playerService.pauseTrack();
          this.audioStore.trackUrl = '';
        }
      );

    this.inactivityMonitor.timeout
      .pipe(takeUntil(this._onDestroy$))
      .subscribe(() => this.logoutProcess());
  }

  public getPermissions() {
    this.authService.loggedIn()
      .subscribe(result => {
        // Check all navigation permissions here
        const userPermissionsObs = this.userService.hasPermissions(['UserManagement', 'SiteManagement', 'EditVendorPaymentInfo']);
        const currentUserObs = this.authService.getCurrentUser();

        forkJoin([userPermissionsObs, currentUserObs]).subscribe(results => {
          var permissions = results[0];
          this._hasUserManagement = permissions['UserManagement'];
          this._hasSiteManagement = permissions['SiteManagement'];
          this._hasEditVendorPaymentInfo = permissions['EditVendorPaymentInfo'];
          const decodedToken = this.jwtTokenService.decodeToken('portal') as JwtClaims;
          this.vendorId = +decodedToken?.vendorId;
          this._canEditVenues = results[1].canEditVenues;

          if (this.routeContains('fundraising')) {

            this.vendorService.getVendorAsCurrentUser()
              .subscribe(
                vendorUser => {

                  this.vendor = vendorUser.vendor;
                  this.vendorPermissionConditions = (!this.hasEditVendorPaymentInfo && this.vendor?.active) || this.hasEditVendorPaymentInfo;
                }
              );

          } else {

            this.vendorPermissionConditions = false;
          }

          this.vendorService.checkBarrelPrinting(this.vendorId || 0).subscribe(v => {
            this.enableBarrelPrinting = v;
          })
        });
      });
  }

  ngOnInit() {

    this.modalService.onHidden.subscribe(() => {
      if (this.tosDialogSubject) {
        this.tosDialogSubject.next(this.bsModalRef.content.accepted);
        this.tosDialogSubject.complete();
        this.tosDialogSubject = null;
        this.bsModalRef = null;
      }
    });

    if (this.router.isActive('/portal', true)) {
      const homeRoute = this.authService.getHomeRoute();
      if (homeRoute == '') {
        this.router.navigate(['/login']);
      }
      this.router.navigate(['/portal/' + homeRoute]);
    }

    this.checkFeatureFlags();

    this.getPermissions();

    const eventTypesObs = this.vendorService.getFundraisingEventTypes();
    const loggedInObs = this.authService.loggedIn();

    forkJoin([loggedInObs, eventTypesObs])
      .subscribe(data => {
        if (data[0]) {
          this.engineService.getAllowedEngineServiceTypes()
            .subscribe(serviceTypes => {

              this.serviceTypes = serviceTypes;
            });
        }

        this._cue5050Enabled = data[1].some(t => t?.fundraisingEventTypeId === 1);
        this._ppwEnabled = data[1].some(t => t?.fundraisingEventTypeId === 2 || t?.fundraisingEventTypeId === 4);
    });


    /*
    this.zone.runOutsideAngular(() => {
      this.interval = setInterval(() => {
        this.updateCanvas();
      }, 30);
    });
    */

    // Create a timer to check the validity of the Bearer token
    // Log the user out automatically if it's invalid
    const loginTimer = timer(5000, 10000).pipe(takeUntil(this._onDestroy$)).subscribe((v) => {

      if (!this.router.isActive('/', true)
        && !this.router.isActive('/login', false)
        && !this.router.isActive('/pot', false)
        && !this.router.isActive('/merchant-login', false)
        && !this.router.isActive('/merchant', false)
        && !this.router.isActive('/passwordreset', false)
        && !this.router.isActive('/404', false)) {

          this.authService.loggedIn()
            .subscribe(
              result => {
                if (!result) {
                  // disable this timer
                  loginTimer.unsubscribe();

                  this.logoutProcess();
                }

            }
          );
        }
    });
  }

  ngAfterViewInit() {
    const height = window.innerHeight;

    const mainView = this.mainViewRef.nativeElement;

    if (mainView) {
      mainView.style.height = height.toString() + 'px';
    }

    this._authService.getCurrentUser().subscribe(user => {

      if (user && !user?.tosAccepted) {

        this.showTosAndUpdateUser(user).subscribe();
      }
    });
  }

  showTosAndUpdateUser(user: User): Observable<boolean> {
    this.tosDialogSubject = new Subject<boolean>();
    this.bsModalRef = this.modalService.show(TosComponent, { class: 'modal-lg', ignoreBackdropClick: true });

    return this.tosDialogSubject.pipe(mergeMap(accepted => {
      if (user.tosAccepted !== accepted) {
        user.tosAccepted = accepted;
        return this.userService.acceptCurrentUserTos(accepted).pipe(map(() => accepted));
      }

      return of(accepted);
    }));
  }

  ngOnDestroy() {

    clearInterval(this.interval);
    this._onDestroy$.next();
    this._onDestroy$.complete();

    this.inactivityMonitor.cleanUp();
  }

  logout() {
    this.authService.logout()
      .subscribe(() => this.router.navigate(['/login']));
  }

  logoutProcess () {

    this.authService.logout()
      .subscribe(
        () => {

          // close all open modals
          for (let i = 1; i <= this.modalService.getModalsCount(); i++) {

            this.modalService.hide(i);
          }

          // display message
          this.dialogService.alert(
            'Session Expired',
            `Your login session has expired`,
            this.viewRef);

          // let the message show for a moment before navigating away
          const logoutTimer = timer(2000, 5000).pipe(takeUntil(this._onDestroy$))
            .subscribe(
              () => {

                logoutTimer.unsubscribe();

                this.zone.run(() => this.router.navigate(['/login']));
              }
            );
        }
      );
  }

  hasEngineServiceType(typeName: string): Observable<boolean> {
    return this.authService.loggedIn().pipe(
      result => {
        if (result) {
          return this.engineService.hasServiceType(typeName);
        } else {
          this.logout();
          return of(false);
        }
      }
    );
  }

  get serviceCount() {
    return this.engineService.getServiceCount();
  }

  testSentry() {
    throw new Error("Did Sentry catch this fake error?");
  }

  checkFeatureFlags() {

    const websiteCustomizationObs = this.authService.checkFeatureFlag('WebsiteCustomization');
    const ppwObs  = this.authService.checkFeatureFlag('PledgePerWin');

    forkJoin([websiteCustomizationObs, ppwObs]).subscribe(data => {
      this._hasWebsiteCustomization = data[0];
      this._hasPledgePerWin = data[1];
    })
  }

  routeContains(route: string): boolean {
    return this.currrentRoute.indexOf(route) !== -1;
  }

  /*
  public updateCanvas() {
    // return if page isn't loaded
    if (!this.backgroundRef) {
      return;
    }

    // get the canvas object and context
    const canvas = this.backgroundRef.nativeElement;
    const ctx = canvas.getContext('2d');

    // get the canvas width and height and adjust its scale
    // based on the canvas size this venue was created with
    const w = canvas.width;
    const h = canvas.height;

    // clear the entire canvas
    ctx.clearRect(0, 0, w, h);

    this.sineWaves.map((s, i) => {
      this.sineWaves[i].phase = this.plotSine(ctx, w, h, s.amplitude, s.phase, s.frequency, s.velocity, s.color);
    });
  }


  plotSine(ctx, w, h, amplitude, phase, frequency, velocity, color): number {

    let x = 0;
    let y = 0;

    ctx.beginPath();
    ctx.lineWidth = 2;
    ctx.strokeStyle = color;
    ctx.lineWidth = 3;

    const midPoint = h / 2;
    while (x < w) {
        y = midPoint + amplitude * Math.sin(x++ / frequency + phase);
        ctx.lineTo(x, y);
    }

    while (x < w) {
      y = midPoint + amplitude * Math.sin(x++ / frequency + phase);
      ctx.lineTo(x, y);
  }
    ctx.stroke();

    phase += velocity;

    return phase >= 6.283 ? 0 : phase;
  }
  */


}

interface SineWave {
  phase: number;
  amplitude: number;
  color: string;
  frequency: number;
  velocity: number;
}
